<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
      <TableHeaderSection
        v-if="hasPermission('create launch_card')"
        :title="`${localization('Launch cards')}`"
        :text="`${localization('Browse groups of launch cards.')}`"
        :buttonText="`${localization('Create new group')}`"
        :total="totalDataCards"
        @toggleModal="createGroup"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          ref="customTable"
          :count="totalDataCards"
          :DataItems="dataCards"
          @Refresh="Refresh"
          @reset="filter = {}"
          :filter="filter"
          :title="`${localization('Launch cards')}`"
          hidden_export_import
          @reset-filters="filter = {}"
          viewName="DataCards"
        >
          <template #columns>
            <el-table-column prop="name" :label="`${localization('Name')}`" sortable>
              <template #default="{ row }">
                <div class="pl-2">
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="topicsGroupCards" :label="`${localization('Topic')}`" sortable>
              <template #default="{ row }">
                <div class="pl-2">
                  {{ row.topicsGroupCards[0].topic_card_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="subTopicsCards" :label="`${localization('Subtopic')}`" sortable>
              <template #default="{ row }">
                <div class="pl-2">
                  <div v-for="subtopic in row.subTopicsCards" :key="subtopic.id">
                    <el-tag size="small" type="success">{{ subtopic.name }}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="isStudent" prop="status" :label="`${localization('Status')}`" sortable>
              <template #default="{ row }">
                <div class="pl-2">
                  <el-tag
                    :type="row.status === 'completed' ? 'success' : row.status === 'answered' ? 'primary' : 'warning'"
                    size="small"
                  >
                    {{ localization(row.status || 'new') }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="!isStudent" prop="subTopicsCardsGrade" :label="`${localization('School Grade')}`" sortable>
              <template #default="{ row }">
                <div class="pl-2">
                  {{ row.topicsGroupCards && row.topicsGroupCards[0] ? row.topicsGroupCards[0].school_grade : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="description" :label="`${localization('Description')}`" sortable>
              <template #default="{ row }">
                <div class="pl-2">
                  {{ row.description }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="actions" width="170">
            <template slot-scope="scope">
              <div class="td-actions"  >
                <span>
                    <a
                      v-if="hasPermission('create launch_card')"
                      v-tooltip.top-center="`${localization('Copy')}`"
                      class="btn btn-success btn-link btn-xs pl-2 pr-2"
                      @click="copyGroup(scope.row)"
                    >
                      <i class="fa fa-copy text-dark"></i>
                    </a>
                    <a
                      v-if="hasPermission('view launch_card')"
                      v-tooltip.top-center="`${localization('Show')}`"
                      class="btn btn-info btn-link btn-xs"
                      @click="showGroup(scope.row.id)"
                    >
                      <i class="fa fa-eye text-dark"></i
                    >
                    </a>
                    <!-- <a
                      v-if="isStudent"
                      v-tooltip.top-center="`${localization('leave group')}`"
                      class="btn btn-danger btn-link btn-lg pl-2 pr-2"
                      @click="leaveGroup(scope.row.id)"
                    >
                      <i class="fa fa-sign-out text-danger"></i>
                    </a> -->
                    <a
                      v-if="isStudent && scope.row.status !== 'completed' && scope.row.subTopicsCards && scope.row.subTopicsCards.length > 0"
                      v-tooltip.top-center="`${localization('View Details')}`"
                      class="btn btn-info btn-link btn-xs pl-2 pr-2"
                      @click="viewSubTopicDetails(scope.row)"
                    >
                      <i class="fa fa-eye text-dark"></i>
                    </a>
                    <a
                      v-if="isStudent && scope.row.subTopicsCards && scope.row.subTopicsCards.length > 0"
                      v-tooltip.top-center="`${localization('Print Answers')}`"
                      class="btn btn-info btn-link btn-xs pl-2 pr-2"
                      @click="printMyAnswers(scope.row)"
                    >
                      <i class="fa fa-print text-primary" style="font-size: 1.25rem;"></i>
                    </a>
                    <a
                      v-if="hasPermission('edit launch_card')"
                      v-tooltip.top-center="`${localization('Edit')}`"
                      class="btn btn-warning btn-link btn-xs pl-2 pr-2"
                      @click="editGroup(scope.row)"
                    >
                      <i class="fa fa-edit text-dark"></i>
                    </a>
                    <a
                      v-if="hasPermission('delete launch_card')"
                      v-tooltip.top-center="`${localization('Delete')}`"
                      @click="deleteGroup(scope.row.id)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                </span>
              </div>
            </template>
             </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Create Group Modal -->
    <el-dialog
      @close="resetForm"
      :title="editMode ? localization('Edit Group') : localization('Create new group')"
      :visible.sync="dialogVisible"
      width="800px"
      top="1%"
      custom-class="task-modal global_modal"
      :close-on-click-modal="true"
    >
      <div class="custom_modal_header">
        <div class="images">
           <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ editMode ? localization("Edit Group") : localization("Create new group") }}
        </h3>
        <p class="description">
          {{ editMode ? localization("Edit the group details.") : localization("Enter the group name and description.") }}
        </p>
      </div>
      <el-form
        :rules="rules"
        ref="addGroupForm"
        :model="form"
        @submit.native.prevent
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="`${localization('Name')}*`"
              prop="name"
            >
              <el-input
                :placeholder="`${localization('Enter group name')}`"
                v-model="form.name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('Topics')}*`"
              prop="topics_card_id"
            >
              <el-select
                v-model="form.topics_card_id"
                filterable
                class="w-100"
                :placeholder="`${localization('Select Topic')}`"
                @change="handleTopicChange"
              >
                <el-option
                  v-for="item in topicsCardLookups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`${localization('Subtopics')}`"
              prop="sub_topics_cards"
            >
              <el-select
                v-model="form.sub_topics_cards"
                multiple
                filterable
                class="w-100"
                :disabled="!form.topics_card_id"
                :placeholder="form.topics_card_id ? `${localization('Select Subtopics')}` : `${localization('Choose a Topic first')}`"
              >
                <el-option
                  v-for="item in subTopicsCardLookups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('School Average Score')}`"
              prop="school_avg_score"
            >
              <el-input
                type="number"
                :placeholder="`${localization('Enter school avg score')}`"
                v-model="form.school_avg_score"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`${localization('District Average Score')}`"
              prop="district_avg_score"
            >
              <el-input
                type="number"
                :placeholder="`${localization('Enter district avg score')}`"
                v-model="form.district_avg_score"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item
              :label="`${localization('State Average Score')}`"
              prop="state_avg_score"
            >
              <el-input
                type="number"
                :placeholder="`${localization('Enter state avg score')}`"
                v-model="form.state_avg_score"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item
              :label="`${localization('School Grade')}`"
              prop="school_grade"
            >
              <el-select
                v-model="form.school_grade"
                class="w-100"
                :placeholder="`${localization('Select School Grade')}`"
              >
                <el-option
                  v-for="grade in GradeList"
                  :key="grade"
                  :label="grade"
                  :value="grade"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
           <el-col :span="24">
            <el-form-item
              :label="`${localization('Description')}`"
              prop="description"
            >
              <el-input
                type="textarea"
                :placeholder="`${localization('Enter group description')}`"
                v-model="form.description"
              ></el-input>
            </el-form-item>
           </el-col>
        </el-row>

        <el-row :gutter="20" v-if="canAssignInstructors">
          <el-col :span="24" v-if="isPlatformAdmin">
            <el-form-item
              :label="`${localization('Institution')}*`"
              prop="organization_id"
            >
              <el-select
                v-model="form.organization_id"
                filterable
                class="w-100"
                :placeholder="`${localization('Select institution')}`"
                @change="handleOrganizationChange"
              >
                <el-option
                  v-for="org in organizations"
                  :key="org.id"
                  :label="org.name"
                  :value="org.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="`${localization('Assign instructors')}`"
              prop="users"
            >
              <el-select
                v-model="form.users"
                multiple
                filterable
                class="w-100"
                :disabled="isInstructorPickerDisabled"
                :placeholder="instructorPickerPlaceholder"
              >
                <el-option
                  v-for="user in instructorOptions"
                  :key="user.id"
                  :label="instructorLabel(user)"
                  :value="user.id"
                >
                </el-option>
              </el-select>
              <p v-if="assignError" class="text-danger small mt-1 mb-0">{{ assignError }}</p>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save lci_btn_modal_cancel">
          {{ editMode ? localization("Save") : localization("Create") }}
        </button>
      </div>
    </el-dialog>

    <!-- Start Design For Print -->
    <div v-if="printingMember" class="the_main_container_for_print_all_pdf bg-white">
      <div class="main_container p-4">
        <!-- User Header info -->
        <div class="main_auth_user_info text-center border-bottom pb-4 mb-4">
          <h2 class="n_name font-weight-bold mb-1">
            {{ printingMember.user.first_name }} {{ printingMember.user.last_name }}
          </h2>
          <p class="n_email text-muted mb-2">{{ printingMember.user.email }}</p>
          <span class="badge badge-primary px-3 py-2 text-white" style="font-size: 1rem; background-color: #7f56d9;">
            {{ localization('Topic') }}: {{ printingMember.topicName }}
          </span>
        </div>

        <!-- Subtopics and Answers -->
        <div
          v-for="(subtopic, subIndex) in printingMember.subtopics"
          :key="subtopic.id"
          class="print-page-break mb-5"
        >
          <div class="subtopic-print-header mb-4">
            <h3 class="font-weight-bold text-dark mb-1" style="font-size: 1.5rem; border-left: 4px solid #7f56d9; padding-left: 10px;">
              {{ subtopic.name }}
            </h3>
            <p class="text-muted">{{ subtopic.description }}</p>
          </div>

          <!-- Components -->
          <div v-if="subtopic.components && subtopic.components.length > 0">
            <div
              v-for="(component, compIndex) in subtopic.components"
              :key="component.id"
              class="component-print-block mb-4 p-3 border rounded page-break-inside-avoid"
            >
              <h4 class="font-weight-bold text-secondary mb-2" style="font-size: 1.15rem;">
                {{ component.title }}
              </h4>
              <div class="component-body mb-3 text-muted" v-if="component.body" v-html="component.body"></div>

              <!-- Question Cards -->
              <div v-if="component.question_cards && component.question_cards.length > 0" class="mt-3">
                <div v-for="(qCard, qIndex) in component.question_cards" :key="qCard.id" class="mb-4">
                  <!-- MCQ Choices -->
                  <div v-if="qCard.type === 'mcq' && qCard.choices && qCard.choices.length > 0">
                    <div class="d-flex align-items-start mb-2 pl-3 border-left" style="border-width: 3px !important; border-color: #7f56d9 !important;">
                      <span class="badge badge-secondary mr-2 mt-1 text-white" style="background-color: #7f56d9;">
                        {{ qIndex + 1 }}
                      </span>
                      <span class="font-weight-bold text-dark" style="font-size: 0.95rem;">
                        {{ qCard.question }}
                      </span>
                    </div>
                    <div class="pl-5 mt-2">
                      <div
                        v-for="choice in qCard.choices"
                        :key="choice.id"
                        class="choice-row d-flex align-items-center mb-1 p-2 rounded border"
                        :style="qCard.student_answer === choice.id ? 'background-color: #f9f5ff; border-color: #7f56d9; border-left: 4px solid #7f56d9;' : 'background-color: #ffffff; border-color: #eaecf0;'"
                      >
                        <i v-if="qCard.student_answer === choice.id" class="fa fa-dot-circle-o text-primary mr-2" style="color: #7f56d9;"></i>
                        <i v-else class="fa fa-circle-o text-muted mr-2"></i>
                        <span :class="{'text-primary font-weight-bold': qCard.student_answer === choice.id, 'text-secondary': qCard.student_answer !== choice.id}">
                          {{ choice.text }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Text Answer (Essay styled card) -->
                  <div v-else class="essay-question-container text-left">
                    <div class="essay-question-header">
                      <div class="essay-step-label">
                        Step {{ parseQuestionCard(qCard, qIndex).stepNumber }}: <strong>{{ parseQuestionCard(qCard, qIndex).stepName }}</strong>
                      </div>
                      <div class="essay-main-question">
                        {{ parseQuestionCard(qCard, qIndex).mainQuestion }}
                      </div>
                      <div class="essay-help-text" v-if="parseQuestionCard(qCard, qIndex).helpText" v-html="formatHelpText(parseQuestionCard(qCard, qIndex).helpText)">
                      </div>
                    </div>
                    <div class="essay-question-body">
                      <div class="essay-answer-preview">
                        {{ qCard.student_answer || qCard.answer || localization('No answer submitted yet.') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import request, { extractApiError } from "@/utils/request";

export default {
  name: "DataCardsIndex",
  data() {
    return {
      GradeList:['1', '2', '3', '4','5','6','7','8'],
      filter: {},
      dialogVisible: false,
      editMode: false,
      editingGroupId: null,
      printingMember: null,
      localLoading: false,
      assignError: "",
      assignedMembersSnapshot: [],
      form: {
        name: "",
        description: "",
        topics_card_id: null,
        sub_topics_cards: [],
        school_avg_score: "",
        district_avg_score: "",
        state_avg_score: "",
        school_grade: "",
        users: [],
        organization_id: null
      }
    };
  },
  computed: {
    ...mapGetters({
      dataCards: ["data_cards/dataCards"],
      totalDataCards: ["data_cards/totalDataCards"],
      loading: ["data_cards/loading"],
    }),
    ...mapGetters("topics_card", ["topicsCardLookups"]),
    ...mapGetters("sub_topics_card", ["subTopicsCardLookups"]),
    ...mapGetters("data_cards", ["institutionInstructors"]),
    organizations() {
      return this.$store.getters["organization/orgs"] || [];
    },
    authRoleNames() {
      const roles = this.$store.getters["roles/authUserRoles"] || [];
      return roles.map(r => String(r).toLowerCase());
    },
    isPlatformAdmin() {
      return this.authRoleNames.includes("admin");
    },
    isInstitutionAdmin() {
      return this.authRoleNames.includes("admin institution")
        || this.authRoleNames.includes("institution_admin")
        || this.authRoleNames.includes("institution admin");
    },
    canAssignInstructors() {
      return this.isPlatformAdmin || this.isInstitutionAdmin;
    },
    isInstructorPickerDisabled() {
      return this.isPlatformAdmin && !this.form.organization_id;
    },
    instructorPickerPlaceholder() {
      if (this.isInstructorPickerDisabled) {
        return this.localization("Select an institution first");
      }
      return this.localization("Select instructors");
    },
    instructorOptions() {
      const byId = {};
      (this.institutionInstructors || []).forEach(user => {
        if (user && user.id != null) {
          byId[user.id] = user;
        }
      });
      (this.assignedMembersSnapshot || []).forEach(user => {
        if (user && user.id != null && !byId[user.id]) {
          byId[user.id] = user;
        }
      });
      return Object.values(byId);
    },
    isStudent() {
      const user = this.auth();
      const type = user && user.type ? String(user.type).toLowerCase() : '';
      const roles = this.$store.getters["roles/authUserRoles"] || [];
      const hasStudentRole = roles.some(r => r && String(r).toLowerCase() === 'user');
      return type === 'user' || hasStudentRole;
    },
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        topics_card_id: [
          {
            required: true,
            message: this.localization("Please select a topic"),
            trigger: "change"
          }
        ],
        school_avg_score: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        district_avg_score: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        state_avg_score: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        school_grade: [
          {
            required: true,
            message: this.localization("Please select a grade"),
            trigger: "change"
          }
        ]
      };
    }
  },
  methods: {
    Refresh(query) {
      if (query) {
        this.$store.dispatch("data_cards/GetDataCards", { query: query });
      } else if (this.$refs.customTable) {
        this.$refs.customTable.Refresh();
      } else {
        this.$store.dispatch("data_cards/GetDataCards", { query: {} });
      }
    },
    emptyForm() {
      return {
        name: "",
        description: "",
        topics_card_id: null,
        sub_topics_cards: [],
        school_avg_score: "",
        district_avg_score: "",
        state_avg_score: "",
        school_grade: "",
        users: [],
        organization_id: null
      };
    },
    instructorLabel(user) {
      const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      if (name && user.email) {
        return `${name} (${user.email})`;
      }
      return name || user.email || String(user.id);
    },
    groupUsersFromRow(row) {
      return row && row.usersGroupCards
        ? row.usersGroupCards.map(u => u.id || u.user_id).filter(id => id != null)
        : [];
    },
    fetchInstitutionInstructors() {
      if (!this.canAssignInstructors) {
        return;
      }
      if (this.isPlatformAdmin && !this.form.organization_id) {
        this.$store.commit("data_cards/SET_INSTITUTION_INSTRUCTORS", []);
        return;
      }
      const query = {};
      if (this.isPlatformAdmin && this.form.organization_id) {
        query.organization_id = this.form.organization_id;
      }
      const groupCardId = (!this.isPlatformAdmin && this.editMode) ? this.editingGroupId : null;
      this.$store.dispatch("data_cards/GetInstitutionInstructors", {
        query,
        groupCardId
      }).catch((error) => {
        this.assignError = extractApiError(error);
      });
    },
    handleOrganizationChange() {
      this.assignError = "";
      this.form.users = [];
      this.fetchInstitutionInstructors();
    },
    prepareAssignForm(row) {
      this.assignError = "";
      this.assignedMembersSnapshot = (row && row.usersGroupCards) ? row.usersGroupCards.slice() : [];
      if (this.isPlatformAdmin) {
        this.$store.dispatch("organization/orgs");
      }
      this.fetchInstitutionInstructors();
    },
    buildGroupPayload() {
      const selectedUsers = this.form.users || [];
      let users = selectedUsers;
      if (this.editMode && this.assignedMembersSnapshot.length) {
        const instructorIds = new Set((this.institutionInstructors || []).map(u => u.id));
        const preserved = this.assignedMembersSnapshot
          .map(u => u.id)
          .filter(id => id != null && !instructorIds.has(id) && !selectedUsers.includes(id));
        users = [...selectedUsers, ...preserved];
      }
      const payload = {
        name: this.form.name,
        description: this.form.description,
        topics_card_id: this.form.topics_card_id,
        sub_topics_cards: this.form.sub_topics_cards,
        school_avg_score: this.form.school_avg_score,
        district_avg_score: this.form.district_avg_score,
        state_avg_score: this.form.state_avg_score,
        school_grade: this.form.school_grade,
        users
      };
      if (this.isPlatformAdmin && this.form.organization_id) {
        payload.organization_id = this.form.organization_id;
      }
      return payload;
    },
    createGroup() {
      this.editMode = false;
      this.editingGroupId = null;
      this.form = this.emptyForm();
      this.dialogVisible = true;
      this.prepareAssignForm(null);
    },
    handleTopicChange(topicId) {
      this.form.sub_topics_cards = [];
      if (topicId) {
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: topicId });
      }
    },
    copyGroup(row) {
      this.editMode = false;
      this.editingGroupId = null;
      const firstTopicCard = row.topicsGroupCards && row.topicsGroupCards[0];
      this.form = {
        name: row.name ? `${row.name}` : "",
        description: row.description || "",
        topics_card_id: firstTopicCard ? firstTopicCard.topic_card_id : null,
        sub_topics_cards: row.subTopicsCards ? row.subTopicsCards.map(st => st.id) : [],
        school_avg_score: firstTopicCard ? firstTopicCard.school_avg_score : "",
        district_avg_score: firstTopicCard ? firstTopicCard.district_avg_score : "",
        state_avg_score: firstTopicCard ? firstTopicCard.state_avg_score : "",
        school_grade: firstTopicCard ? firstTopicCard.school_grade ? String(firstTopicCard.school_grade) : "" : "",
        users: this.groupUsersFromRow(row),
        organization_id: this.isPlatformAdmin ? (row.organization_id || null) : null
      };
      if (this.form.topics_card_id) {
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: this.form.topics_card_id });
      }
      this.dialogVisible = true;
      this.prepareAssignForm(row);
    },
    editGroup(row) {
      this.editMode = true;
      this.editingGroupId = row.id;
      const firstTopicCard = row.topicsGroupCards && row.topicsGroupCards[0];
      this.form = {
        name: row.name || "",
        description: row.description || "",
        topics_card_id: firstTopicCard ? firstTopicCard.topic_card_id : null,
        sub_topics_cards: row.subTopicsCards ? row.subTopicsCards.map(st => st.id) : [],
        school_avg_score: firstTopicCard ? firstTopicCard.school_avg_score : "",
        district_avg_score: firstTopicCard ? firstTopicCard.district_avg_score : "",
        state_avg_score: firstTopicCard ? firstTopicCard.state_avg_score : "",
        school_grade: firstTopicCard ? firstTopicCard.school_grade ? String(firstTopicCard.school_grade) : "" : "",
        users: this.groupUsersFromRow(row),
        organization_id: this.isPlatformAdmin ? (row.organization_id || null) : null
      };
      if (this.form.topics_card_id) {
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: this.form.topics_card_id });
      }
      this.dialogVisible = true;
      this.prepareAssignForm(row);
    },
    resetForm() {
      this.form = this.emptyForm();
      this.editMode = false;
      this.editingGroupId = null;
      this.assignError = "";
      this.assignedMembersSnapshot = [];
      this.$store.commit("data_cards/SET_INSTITUTION_INSTRUCTORS", []);
      this.dialogVisible = false;
    },
    showGroup(id, isNew = false) {
      const query = isNew ? { newGroup: true } : {};
      this.$router.push({ name: "Data Card Details", params: { id: id }, query: query });
    },
    submitForm() {
      this.$refs.addGroupForm.validate((valid) => {
        if (valid) {
          this.assignError = "";
          const isEditMode = this.editMode;
          const payload = this.buildGroupPayload();
          const action = isEditMode
            ? this.$store.dispatch("data_cards/UpdateGroup", { id: this.editingGroupId, data: payload })
            : this.$store.dispatch("data_cards/CreateDataCard", payload);

          action.then((response) => {
              this.resetForm();
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
              });

              if (!isEditMode) {
                const id = response && (response.id || (response.groupCard && response.groupCard.id));
                if (id) {
                  this.showGroup(id, true);
                } else {
                  this.Refresh();
                }
              } else {
                this.Refresh();
              }
            })
            .catch((error) => {
              this.assignError = extractApiError(error);
            });
        }
      });
    },
    deleteGroup(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("data_cards/DeleteDataCard", id).then(() => {
            this.Refresh();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    },
    leaveGroup(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are you sure you want to leave this group?")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Leave")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("data_cards/UnAssignMe", id).then(() => {
            this.Refresh();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Left the group successfully")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          }).catch(() => {
            this.$message({
              message: this.localization("Failed to leave the group. Please try again."),
              type: "error"
            });
          });
        }
      });
    },
    viewSubTopicDetails(row) {
      if (row.subTopicsCards && row.subTopicsCards.length > 0) {
        this.$router.push({
          path: `/sub_topics_card/details/${row.subTopicsCards[0].id}`,
          query: { group_id: row.id }
        });
      }
    },
    printMyAnswers(row) {
      if (!row.subTopicsCards || row.subTopicsCards.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: this.localization('No subtopics assigned to this group.'),
          confirmButtonText: this.localization('Ok'),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning"
        });
        return;
      }

      const user = this.auth();
      if (!user) {
        return;
      }

      const subtopicIds = row.subTopicsCards.map(s => s.id);
      this.localLoading = true;

      const promises = subtopicIds.map(id => {
        return request({
          url: `/sub_topics_card/show/${id}`,
          method: 'get',
          params: { user_id: user.id }
        });
      });

      Promise.all(promises).then(responses => {
        const subtopics = responses.map(r => r.subTopicsCard);

        const firstTopicName = row.topicsGroupCards && row.topicsGroupCards[0]
          ? row.topicsGroupCards[0].topic_card_name
          : '';

        this.printingMember = {
          user: user,
          subtopics: subtopics,
          topicName: firstTopicName
        };

        // Wait for DOM update
        this.$nextTick(() => {
          const originalTitle = document.title;
          const userName = `${user.first_name} ${user.last_name}`;
          const subtopicNames = subtopics.map(s => s.name).join(' - ');
          document.title = `${userName} - ${subtopicNames}`;

          window.print();

          document.title = originalTitle;
          // Reset printingMember after print
          this.printingMember = null;
        });
      }).catch(err => {
        console.error(err);
        Swal.fire({
          icon: 'error',
          text: this.localization('Failed to load answers for printing.'),
          confirmButtonText: this.localization('Ok'),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-danger"
        });
      }).finally(() => {
        this.localLoading = false;
      });
    }
  },
  mounted() {
    this.$store.dispatch("topics_card/GetTopicsCardLookups");
  },
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}

/* Modal Styles reused/adapted from Groups */
.lci_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3%;
  .lci_btn_modal_cancel {
    background-color: #fff;
    color: #667085;
    border-radius: 8px;
    padding: 12px 20px;
    border: 1px solid #eaecf0;
    width: calc(97% / 2);
    &.save {
      background-color: #7f56d9;
      color: #fff;
    }
  }
}
</style>

<style lang="scss" scoped>
@media print {
  /* Hide main app wrapper and other non-printable contents */
  #app,
  .main-panel,
  .sidebar,
  .navbar,
  .footer,
  .main_profile_wrapper > *:not(.the_main_container_for_print_all_pdf) {
    display: none !important;
  }

  body {
    background-color: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .the_main_container_for_print_all_pdf {
    display: block !important;
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    background: #fff !important;
  }

  .subtopic-print-header {
    page-break-after: avoid !important;
    break-after: avoid-page !important;
  }

  .component-print-block + .component-print-block {
    page-break-before: always !important;
    break-before: page !important;
  }

  .print-page-break {
    page-break-after: always !important;
    break-after: page !important;
    padding: 5mm !important;
    box-sizing: border-box !important;
  }

  .page-break-inside-avoid {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
}
</style>
